import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import StudentsPage from "@/pages/StudentsPage";
import NewInspectionPage from "@/pages/NewInspectionPage";
import RecordsPage from "@/pages/RecordsPage";
import UsersPage from "@/pages/UsersPage";
import FinesPage from "@/pages/FinesPage";
import MyAccountPage from "@/pages/MyAccountPage";
import InstallAppPrompt from "@/components/app/InstallAppPrompt";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-carmel-slateBg">
        <Loader2 className="w-6 h-6 animate-spin text-carmel-gold" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/students" element={<ProtectedRoute roles={["admin", "editor"]}><StudentsPage /></ProtectedRoute>} />
      <Route path="/inspections/new" element={<ProtectedRoute roles={["admin", "editor"]}><NewInspectionPage /></ProtectedRoute>} />
      <Route path="/records" element={<ProtectedRoute><RecordsPage /></ProtectedRoute>} />
      <Route path="/fines" element={<ProtectedRoute><FinesPage /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute roles={["admin"]}><MyAccountPage /></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute roles={["admin"]}><UsersPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster richColors position="top-right" />
          <InstallAppPrompt />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
